'use client';
import isEmpty from 'lodash.isempty';
import React, { useRef, useState, useCallback, useEffect, createContext, useContext } from 'react';
import { LOG_MODE } from '../constants/global.mjs';
import { logging } from '../hooks/useApplyLogging.mjs';

// 샘플링 비율
const SAMPLE_RATE = 0.05;
const RenderContext = /*#__PURE__*/createContext({
  register: _ => {},
  isTargetUser: false
});
function isLogging(logMode) {
  switch (logMode) {
    case LOG_MODE.PRODUCTION:
      return Math.random() >= 1 - SAMPLE_RATE;
    case LOG_MODE.DEVELOPMENT:
      return true;
    case LOG_MODE.NONE:
      return false;
    default:
      return false;
  }
}
function RenderProvider(_ref) {
  let {
    children,
    logMode = LOG_MODE.PRODUCTION
  } = _ref;
  const isTargetUserRef = useRef(isLogging(logMode));
  const [componentMap, setComponentMap] = useState({});
  const register = useCallback(target => {
    setComponentMap(prevComponentMap => {
      try {
        const nextMap = {
          ...prevComponentMap
        };
        if (nextMap[target]) {
          nextMap[target]++;
        } else {
          nextMap[target] = 1;
        }
        return nextMap;
      } catch {}
      return prevComponentMap;
    });
  }, []);
  const clear = useCallback(() => {
    setComponentMap({});
  }, []);
  useEffect(() => {
    try {
      if (isTargetUserRef.current && !isEmpty(componentMap)) {
        logging(location.href, componentMap, logMode === LOG_MODE.DEVELOPMENT);
        clear();
      }
    } catch {}
  }, [componentMap, clear, logMode]);
  return /*#__PURE__*/React.createElement(RenderContext.Provider, {
    value: {
      register,
      isTargetUser: isTargetUserRef.current
    }
  }, children);
}
const useRenderContext = () => {
  const context = useContext(RenderContext);
  if (!context) {
    throw new Error('[deFign/RenderProvider] Could not use RenderProvider');
  }
  return context;
};

export { RenderProvider as default, useRenderContext };
